import { publicRequest } from "../requestMethods/requestMethods";

export const sendEmail =  async (body) => {
    try {
      const response = await publicRequest.post(`/send-email`, body);
      return response.data;
    } catch (error) {
      console.error('Error creating user:', error);
      throw new Error('Error creating users');
    }
};